import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d08615b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outer-accordion accordion accordion-unbordered accordion-multiselectable" }
const _hoisted_2 = { class: "product-box" }
const _hoisted_3 = ["aria-controls", "aria-expanded", "id"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6 align-self-center" }
const _hoisted_6 = { class: "col-6 accordion-label" }
const _hoisted_7 = {
  key: 0,
  class: "m-2 green-badge badge badge-small accordion-label ml-3",
  id: "label-low-score"
}
const _hoisted_8 = {
  key: 1,
  class: "m-2 yellow-badge badge badge-small accordion-label ml-3",
  id: "label-high-score"
}
const _hoisted_9 = {
  key: 2,
  class: "m-2 green-badge badge badge-small accordion-label ml-3",
  id: "label-low-co2"
}
const _hoisted_10 = {
  key: 3,
  class: "m-2 yellow-badge badge badge-small accordion-label ml-3",
  id: "label-high-co2"
}
const _hoisted_11 = ["id", "aria-hidden"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-6" }, null, -1))
const _hoisted_13 = ["id"]
const _hoisted_14 = {
  key: 0,
  class: "col-4 actions"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_16 = ["id"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#playlist-add-check" })
], -1))
const _hoisted_18 = ["id"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_21 = ["id"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#list-alt" })
], -1))
const _hoisted_23 = ["id"]
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = { class: "table table--borderless table--compact table--responsive-headers d-print-table" }
const _hoisted_26 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_27 = { class: "align-text-right result-value" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_29 = { class: "align-text-right" }
const _hoisted_30 = ["data-tooltip"]
const _hoisted_31 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "sr-only" }
const _hoisted_35 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_36 = { class: "align-text-right result-value" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_38 = { class: "align-text-right" }
const _hoisted_39 = ["data-tooltip"]
const _hoisted_40 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "sr-only" }
const _hoisted_44 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_45 = { class: "align-text-right result-value" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_47 = { class: "align-text-right" }
const _hoisted_48 = ["data-tooltip"]
const _hoisted_49 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "sr-only" }
const _hoisted_53 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_54 = { class: "align-text-right result-value" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_56 = { class: "align-text-right" }
const _hoisted_57 = ["data-tooltip"]
const _hoisted_58 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { class: "sr-only" }
const _hoisted_62 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_63 = { class: "align-text-right result-value" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_65 = { class: "align-text-right" }
const _hoisted_66 = ["data-tooltip"]
const _hoisted_67 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = { class: "sr-only" }
const _hoisted_71 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_72 = { class: "align-text-right result-value" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr./år", -1))
const _hoisted_74 = { class: "align-text-right" }
const _hoisted_75 = ["data-tooltip"]
const _hoisted_76 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = { class: "sr-only" }
const _hoisted_80 = { class: "highlighted-co2" }
const _hoisted_81 = { class: "w-percent-md-50 result-label" }
const _hoisted_82 = { class: "align-text-right result-value" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, [
  /*#__PURE__*/_createTextVNode("tons CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode("e")
], -1))
const _hoisted_84 = { class: "align-text-right" }
const _hoisted_85 = ["data-tooltip"]
const _hoisted_86 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = { class: "sr-only" }
const _hoisted_90 = { class: "highlighted" }
const _hoisted_91 = { class: "w-percent-md-50 result-label" }
const _hoisted_92 = { class: "align-text-right result-value" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_94 = { class: "align-text-right" }
const _hoisted_95 = ["data-tooltip"]
const _hoisted_96 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = { class: "sr-only" }
const _hoisted_100 = {
  key: 1,
  class: "col-4 mr-6"
}
const _hoisted_101 = { class: "accordion accordion-unbordered accordion-multiselectable" }
const _hoisted_102 = ["aria-controls", "aria-expanded", "id"]
const _hoisted_103 = { class: "variant-label" }
const _hoisted_104 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_105 = ["id", "aria-hidden"]
const _hoisted_106 = { class: "table table--borderless table--compact table--responsive-headers d-print-table" }
const _hoisted_107 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_108 = { class: "align-text-right result-value" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_111 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_112 = { class: "align-text-right result-value" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_115 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_116 = { class: "align-text-right result-value" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_119 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_120 = { class: "align-text-right result-value" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_123 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_124 = { class: "align-text-right result-value" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_127 = { class: "w-percent-md-50 not-bold result-label" }
const _hoisted_128 = { class: "align-text-right result-value" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr./år", -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_131 = { class: "highlighted-co2" }
const _hoisted_132 = { class: "w-percent-md-50 result-label" }
const _hoisted_133 = { class: "align-text-right result-value" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, [
  /*#__PURE__*/_createTextVNode("tons CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode("e")
], -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_136 = { class: "highlighted" }
const _hoisted_137 = { class: "w-percent-md-50 result-label" }
const _hoisted_138 = { class: "align-text-right result-value" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "result-unit" }, "kr.", -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_141 = { key: 0 }
const _hoisted_142 = {
  key: 1,
  class: "alert alert-info alert-co2"
}
const _hoisted_143 = { class: "alert-body" }
const _hoisted_144 = { class: "alert-heading" }
const _hoisted_145 = { class: "alert-text" }
const _hoisted_146 = { class: "alert-text nobullet-list" }
const _hoisted_147 = {
  key: 3,
  class: "alert alert-info alert-tco"
}
const _hoisted_148 = { class: "alert-body" }
const _hoisted_149 = { class: "alert-heading" }
const _hoisted_150 = { class: "alert-text" }
const _hoisted_151 = { class: "alert-text nobullet-list" }
const _hoisted_152 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RichTekst = _resolveComponent("RichTekst")!
  const _component_CO2ComparisonChart = _resolveComponent("CO2ComparisonChart")!
  const _component_TCOScoreProductComparisonChart = _resolveComponent("TCOScoreProductComparisonChart")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.filteredCompanies, (p, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: p,
        class: _normalizeClass({ 'force-page-break': _ctx.printMode && index !== (this.filteredCompanies.length - 1) && _ctx.accordionsOpen })
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            "aria-controls": 'product-'+index,
            "aria-expanded": this.accordionsOpen,
            class: "accordion-button product-accordion",
            id: 'product-button-'+index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", null, _toDisplayString(p.companyName), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (p.showLowestScoreLabel)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
                      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.laveste-total" })
                    ]))
                  : _createCommentVNode("", true),
                (p.showHighestScoreLabel)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_8, [
                      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.højeste-total" })
                    ]))
                  : _createCommentVNode("", true),
                (p.showLowestCO2Label)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.laveste-co2" })
                    ]))
                  : _createCommentVNode("", true),
                (p.showHighestCO2Label)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
                      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.højeste-co2" })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 8, _hoisted_3),
          _createElementVNode("div", {
            id: 'product-'+index,
            "aria-hidden": !this.accordionsOpen,
            class: "accordion-content product-accordion"
          }, [
            _hoisted_12,
            _createElementVNode("div", {
              class: "row",
              id: 'row-'+index
            }, [
              (!this.printMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("h5", null, [
                      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.handlinger" })
                    ]),
                    _hoisted_15,
                    _createElementVNode("div", {
                      class: "action-div",
                      id: 'contact-' + index
                    }, [
                      _createVNode(_component_router_link, {
                        to: { path: '/kontaktTG/' + p.blanketId, query: { og_id: this.evaluation.id }},
                        class: "function-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.kontakt" })
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ], 8, _hoisted_16),
                    _createElementVNode("div", {
                      class: "action-div",
                      id: 'download-' + index
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.printEvaluering(this.evaluation.id, p.blanketId)),
                        class: "function-link"
                      }, [
                        _hoisted_20,
                        _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.download" })
                      ], 8, _hoisted_19)
                    ], 8, _hoisted_18),
                    _createElementVNode("div", {
                      class: "action-div",
                      id: 'summary-' + index
                    }, [
                      _createVNode(_component_router_link, {
                        to: '/opsummeringTG/noContactInfo/' + p.blanketId,
                        class: "function-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_22,
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.opsummering" })
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ], 8, _hoisted_21)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass((this.printMode ? 'col-11 summary-margins' : 'col-7') + ' summary-details mb-4'),
                id: 'average-table-' + index
              }, [
                _createElementVNode("h5", _hoisted_24, [
                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultatgennemsnit" })
                ]),
                _createElementVNode("div", {
                  class: "result-rows",
                  style: _normalizeStyle(_ctx.cssVars)
                }, [
                  _createElementVNode("table", _hoisted_25, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_26, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat0" })
                        ]),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(this.formatNumeric(p.averageScore.tcoTotalsInitialAmount, '')), 1),
                        _hoisted_28,
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.evaluering.tooltip0'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.keyHasValue('tco.evaluering.tooltip0', 'tco.tg-resultat.tooltip0'))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_31, _hoisted_33))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_34, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip0" })
                            ])
                          ], 8, _hoisted_30)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_35, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat1" })
                        ]),
                        _createElementVNode("td", _hoisted_36, _toDisplayString(this.formatNumeric(p.averageScore.tcoTotalsOperationalAmount, '')), 1),
                        _hoisted_37,
                        _createElementVNode("td", _hoisted_38, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.evaluering.tooltip1'),
                            "data-tooltip-trigger": "click"
                          }, [
                            ( _ctx.keyHasValue('tco.evaluering.tooltip1', 'tco.tg-resultat.tooltip1'))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_40, _hoisted_42))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_43, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip1" })
                            ])
                          ], 8, _hoisted_39)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_44, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat2" })
                        ]),
                        _createElementVNode("td", _hoisted_45, _toDisplayString(this.formatNumeric(p.averageScore.tcoTotalsServiceAmount, '')), 1),
                        _hoisted_46,
                        _createElementVNode("td", _hoisted_47, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.evaluering.tooltip2'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.keyHasValue('tco.evaluering.tooltip2', 'tco.tg-resultat.tooltip2'))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_49, _hoisted_51))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_52, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip2" })
                            ])
                          ], 8, _hoisted_48)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_53, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat3" })
                        ]),
                        _createElementVNode("td", _hoisted_54, _toDisplayString(this.formatNumeric(p.averageScore.tcoTotalsExitAmount, '')), 1),
                        _hoisted_55,
                        _createElementVNode("td", _hoisted_56, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.evaluering.tooltip3'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.keyHasValue('tco.evaluering.tooltip3', 'tco.tg-resultat.tooltip3'))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_58, _hoisted_60))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_61, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip3" })
                            ])
                          ], 8, _hoisted_57)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_62, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat4" })
                        ]),
                        _createElementVNode("td", _hoisted_63, _toDisplayString(this.formatNumeric(p.averageScore.tcoTotalsEnvironmentalAmount, '')), 1),
                        _hoisted_64,
                        _createElementVNode("td", _hoisted_65, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.evaluering.tooltip4'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.keyHasValue('tco.evaluering.tooltip4', 'tco.tg-resultat.tooltip4'))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_67, _hoisted_69))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_70, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip4" })
                            ])
                          ], 8, _hoisted_66)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_71, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat5" })
                        ]),
                        _createElementVNode("td", _hoisted_72, _toDisplayString(this.formatNumeric(p.averageScore.tcoTotalsTotalPerYearAmount, '')), 1),
                        _hoisted_73,
                        _createElementVNode("td", _hoisted_74, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.evaluering.tooltip5'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.keyHasValue('tco.evaluering.tooltip5', 'tco.tg-resultat.tooltip5'))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_76, _hoisted_78))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_79, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip5" })
                            ])
                          ], 8, _hoisted_75)
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_80, [
                        _createElementVNode("th", _hoisted_81, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat6" })
                        ]),
                        _createElementVNode("td", _hoisted_82, _toDisplayString(this.formatNumeric(p.averageScore.tcoTotalsCO2EmissionQuantity, '', true)), 1),
                        _hoisted_83,
                        _createElementVNode("td", _hoisted_84, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.evaluering.tooltip6'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.keyHasValue('tco.evaluering.tooltip6', 'tco.tg-resultat.tooltip6'))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_86, _hoisted_88))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_89, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip6" })
                            ])
                          ], 8, _hoisted_85)
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_90, [
                        _createElementVNode("th", _hoisted_91, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat7" })
                        ]),
                        _createElementVNode("td", _hoisted_92, _toDisplayString(this.formatNumeric(p.averageScore.tcoTotalsTotalAmount, '')), 1),
                        _hoisted_93,
                        _createElementVNode("td", _hoisted_94, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.evaluering.tooltip7'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.keyHasValue('tco.evaluering.tooltip7', 'tco.tg-resultat.tooltip7'))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_96, _hoisted_98))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_99, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip7" })
                            ])
                          ], 8, _hoisted_95)
                        ])
                      ])
                    ])
                  ])
                ], 4)
              ], 10, _hoisted_23),
              (!this.printMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_100))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass((this.printMode ? 'col-11' : 'col-7'))
              }, [
                _createElementVNode("ul", _hoisted_101, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.productVariants, (v, indexInner) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: v,
                      class: _normalizeClass(["mb-4", { 'print-break-before': _ctx.printMode }])
                    }, [
                      _createElementVNode("button", {
                        "aria-controls": 'product-variant-' + index + indexInner,
                        "aria-expanded": this.accordionsOpen,
                        class: "accordion-button variant-button",
                        id: 'product-variant-button-' + index + indexInner
                      }, [
                        _createElementVNode("span", _hoisted_103, _toDisplayString(v.name), 1),
                        _hoisted_104,
                        _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.totalomkostninger" }),
                        _createTextVNode(" " + _toDisplayString(this.formatNumeric(v.score.tcoTotalsTotalAmount, 'kr.')), 1)
                      ], 8, _hoisted_102),
                      _createElementVNode("div", {
                        id: 'product-variant-' + index + indexInner,
                        "aria-hidden": !this.accordionsOpen,
                        class: "accordion-content"
                      }, [
                        _createElementVNode("div", {
                          class: "result-rows",
                          style: _normalizeStyle(_ctx.cssVars)
                        }, [
                          _createElementVNode("table", _hoisted_106, [
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_107, [
                                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat0" })
                                ]),
                                _createElementVNode("td", _hoisted_108, _toDisplayString(this.formatNumeric(v.score.tcoTotalsInitialAmount, '')), 1),
                                _hoisted_109,
                                _hoisted_110
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_111, [
                                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat1" })
                                ]),
                                _createElementVNode("td", _hoisted_112, _toDisplayString(this.formatNumeric(v.score.tcoTotalsOperationalAmount, '')), 1),
                                _hoisted_113,
                                _hoisted_114
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_115, [
                                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat2" })
                                ]),
                                _createElementVNode("td", _hoisted_116, _toDisplayString(this.formatNumeric(v.score.tcoTotalsServiceAmount, '')), 1),
                                _hoisted_117,
                                _hoisted_118
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_119, [
                                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat3" })
                                ]),
                                _createElementVNode("td", _hoisted_120, _toDisplayString(this.formatNumeric(v.score.tcoTotalsExitAmount, '')), 1),
                                _hoisted_121,
                                _hoisted_122
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_123, [
                                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat4" })
                                ]),
                                _createElementVNode("td", _hoisted_124, _toDisplayString(this.formatNumeric(v.score.tcoTotalsEnvironmentalAmount, '')), 1),
                                _hoisted_125,
                                _hoisted_126
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_127, [
                                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat5" })
                                ]),
                                _createElementVNode("td", _hoisted_128, _toDisplayString(this.formatNumeric(v.score.tcoTotalsTotalPerYearAmount, '')), 1),
                                _hoisted_129,
                                _hoisted_130
                              ]),
                              _createElementVNode("tr", _hoisted_131, [
                                _createElementVNode("th", _hoisted_132, [
                                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat6" })
                                ]),
                                _createElementVNode("td", _hoisted_133, _toDisplayString(this.formatNumeric(v.score.tcoTotalsCO2EmissionQuantity, '', true)), 1),
                                _hoisted_134,
                                _hoisted_135
                              ]),
                              _createElementVNode("tr", _hoisted_136, [
                                _createElementVNode("th", _hoisted_137, [
                                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.label.resultat7" })
                                ]),
                                _createElementVNode("td", _hoisted_138, _toDisplayString(this.formatNumeric(v.score.tcoTotalsTotalAmount, '')), 1),
                                _hoisted_139,
                                _hoisted_140
                              ])
                            ])
                          ])
                        ], 4),
                        (_ctx.printMode)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_141))
                          : _createCommentVNode("", true),
                        (_ctx.getOtherProductsWithMatchingCo2EmissionToIndex(p.productVariants, _ctx.getLowestCo2ProductIndex(p.productVariants)).length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                              _createElementVNode("div", _hoisted_143, [
                                _createElementVNode("p", _hoisted_144, [
                                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.advarsel.flere-med-samme-co2.overskrift" })
                                ]),
                                _createElementVNode("p", _hoisted_145, [
                                  _createVNode(_component_RichTekst, { "tekst-noegle": "tco.evaluering.advarsel.flere-med-samme-co2.beskrivelse" })
                                ]),
                                _createElementVNode("ul", _hoisted_146, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOtherProductsWithMatchingCo2EmissionToIndex(p.productVariants, _ctx.getLowestCo2ProductIndex(p.productVariants)), (product) => {
                                    return (_openBlock(), _createElementBlock("li", { key: product }, [
                                      _createElementVNode("b", null, _toDisplayString(product.name), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (v.co2Data)
                          ? (_openBlock(), _createBlock(_component_CO2ComparisonChart, {
                              key: 2,
                              chartData: v.co2Data,
                              chartTitle: _ctx.contentfulTcoModel.findKlarTekst('tco.evaluering.label.graph0'),
                              id: 'co2-chart-' + index + indexInner,
                              printMode: this.printMode
                            }, null, 8, ["chartData", "chartTitle", "id", "printMode"]))
                          : _createCommentVNode("", true),
                        (_ctx.getOtherProductsWithMatchingTotalCostsToIndex(p.productVariants, _ctx.getLowestTotalCostsProductIndex(p.productVariants)).length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                              _createElementVNode("div", _hoisted_148, [
                                _createElementVNode("p", _hoisted_149, [
                                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.advarsel.flere-med-samme-omkostninger.overskrift" })
                                ]),
                                _createElementVNode("p", _hoisted_150, [
                                  _createVNode(_component_RichTekst, { "tekst-noegle": "tco.evaluering.advarsel.flere-med-samme-omkostninger.beskrivelse" })
                                ]),
                                _createElementVNode("ul", _hoisted_151, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOtherProductsWithMatchingTotalCostsToIndex(p.productVariants, _ctx.getLowestTotalCostsProductIndex(p.productVariants)), (product) => {
                                    return (_openBlock(), _createElementBlock("li", { key: product }, [
                                      _createElementVNode("b", null, _toDisplayString(product.name), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_152)),
                        (v.dataCollection)
                          ? (_openBlock(), _createBlock(_component_TCOScoreProductComparisonChart, {
                              key: 5,
                              chartData: v.dataCollection,
                              chartTitle: _ctx.contentfulTcoModel.findKlarTekst('tco.evaluering.label.graph1'),
                              id: 'tco-chart-' + index + indexInner,
                              printMode: this.printMode,
                              class: "printGraph"
                            }, null, 8, ["chartData", "chartTitle", "id", "printMode"]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_105)
                    ], 2))
                  }), 128))
                ])
              ], 2)
            ], 8, _hoisted_13)
          ], 8, _hoisted_11)
        ])
      ], 2))
    }), 128))
  ]))
}